import React from 'react';

import { makeStyles } from '@material-ui/core';

import styles from 'assets/jss/material-dashboard-pro-react/components/cookiesStyle';
import { translate } from 'components/Translation';

import Close from '@material-ui/icons/Close';

import Cookie from 'assets/img/cookie.svg';
import { useDispatch, useSelector } from 'react-redux';
import { hideNotification } from 'redux/modules/settings/cookies/actions';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import { BodyS, BodySBold } from 'components/Typography/Typography';
import apiConfig from 'utils/api/config';

const Cookies = () => {
	// @ts-ignore
	const classes = makeStyles(styles)();

	const dispatch = useDispatch();
	const isShown = useSelector((state: types.redux.rootReducer) => !state.settings?.cookies.cookiesAccepted);

	return (
		<ConditionalRender show={isShown}>
			<aside className={classes.container}>
				<div className={classes.content}>
					<div className={classes.icon}>
						<img src={Cookie} alt="cookie" />
					</div>
					<div className={classes.text}>
						<BodyS inline>{translate('cookies.text')}</BodyS>
						<a target="_blank" rel="noopener noreferrer" href={apiConfig.links.privacyPolicy}>
							<BodySBold color="brand" inline>
								{translate('cookies.use')}
							</BodySBold>
						</a>
					</div>
				</div>
				<div className={classes.close}>
					<Close onClick={() => dispatch(hideNotification())} />
				</div>
			</aside>
		</ConditionalRender>
	);
};

export default Cookies;
